module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/hero-f20163d7536ceec820095aa2b34a07f6.png";